import reframe, { trimv, setGlobalInterceptor } from 'nike-re-framejs';
import Immutable from 'immutable';
import { ENABLE_DEVELOPER_TOOLS } from 'nike-ui/src/devtools/utils';
import { logReframeEventToReduxDevTools, reduxDevtoolsMiddleware } from 'nike-ui/src/devtools/ReduxDevtoolsMiddleware';
import { pushReframeEventToStack, stackMiddleware } from 'nike-ui/src/devtools/StackMiddleware';
import { consoleMiddleware, logReframeEventToConsole } from 'nike-ui/src/devtools/ConsoleMiddleware';
import { getConfigProperty, getLocale } from '@/common/oldMobile';

// funkcionalne eventy pouzivaju tento middleware
setGlobalInterceptor((eventName, eventArgs, dbBefore, dbAfter) => {
    ENABLE_DEVELOPER_TOOLS && logReframeEventToConsole(eventName, eventArgs);
    ENABLE_DEVELOPER_TOOLS && logReframeEventToReduxDevTools(eventName, eventArgs, dbAfter);
    pushReframeEventToStack(eventName, eventArgs);
});

export const defaultMiddlewares = [
    ENABLE_DEVELOPER_TOOLS && consoleMiddleware(),
    ENABLE_DEVELOPER_TOOLS && reduxDevtoolsMiddleware(),
    stackMiddleware(),
    trimv
].filter(v => v);

export function dbPath(path, defVal) {
    return () => reframe.indexPath(path, defVal);
}

export const defaultComparator = (a, b) => (a > b ? 1 : b > a ? -1 : 0);

export const nikeOneMiddlewares = defaultMiddlewares.concat([reframe.path(['nikeone'], Immutable.Map())]);
export const marketStatsMiddlewares = defaultMiddlewares.concat([reframe.path(['market-statistics'], Immutable.Map())]);

export function isString(obj) {
    return typeof obj === 'string' || obj instanceof String;
}

// conditionally add element to array
// usage: [foo, bar, ...whenList(bazToo, baz)]
export const whenList = (cond, what) => (cond ? [what] : []);

// conditionally add element to map
// usage: {foo: fooVal, bar: barVal, ...whenMap(bazToo, { baz: bazVal })}
export const whenMap = (cond, what) => (cond ? what : {});

export const identity = _ => _;

// functional alternative to switch block
// see https://ramdajs.com/docs/#cond
// pair: [boolean, fn]
// in jsx: {cond([loggedIn, () => <LoggedIn />], [loggedOut, () => <LoggedOut />], [newCustomer, () => <CallToAction />])}
export const condWith = predicate => (...pairs) =>
    ([...pairs].find(([first]) => predicate(first)) || [null, () => null])[1]();
export const cond = condWith(identity);

// Creates list of numbers starting from "from" inclusive to "to" exclusive.
// range(0, 5) === [0,1,2,3,4]
// range(0, [1,2,3].length) === [0,1,2]
export const range = (from, to) => {
    const arr = [];
    for (let i = from; i < to; i++) {
        arr.push(i);
    }
    return arr;
};

// zip a with b to the length of a, missing elements in b substitutes with undefined
export const zip = (xs, ys) => xs.reduce((zipped, x, index) => [...zipped, [x, ys[index]]], []);

// flatten one level of nesting [[a, b], c] -> [a, b, c]
export const flatten = xs =>
    xs.reduce((flattened, x) => {
        if (Array.isArray(x)) return [...flattened, ...x];
        return [...flattened, x];
    }, []);

export const dayIterator = (start, end) => ({
    [Symbol.iterator]() {
        let iterator = start.clone();
        return {
            next: () => {
                const result = { value: iterator.clone(), done: iterator.isAfter(end) };
                iterator = iterator.add(1, 'day');
                return result;
            }
        };
    }
});

// Pipes unary functions like this:
// pipe(f, g, h) === arg => h(g(f(arg)))
// Returns unary function;
export const pipe = (...fns) => fns.reduce((acc, fn) => arg => fn(acc(arg)), identity);
export const compose = (...fns) => pipe(...fns.reverse());

export function generateStoryImageUrl(imageId, configPropertyName, visible) {
    return visible ? `url('${getConfigProperty(configPropertyName)}mobile/${imageId}-${getLocale()}')` : '';
}
